module.exports = __webpack_public_path__ + "static/media/berenang-icon.70108de5.png";